module.exports = __webpack_public_path__ + "img/index-item2.53b1f4bb.png";